import styled from 'foundations-theming/utils';
const EditorRelatedConditionsContainer = styled.div.withConfig({
  displayName: "EditorRelatedConditionsContainer",
  componentId: "sc-1vgqs9h-0"
})(["padding-left:50px;> *{position:relative;margin-top:32px;&::before{content:'';position:absolute;background-color:", ";left:-25px;top:-33px;bottom:-1px;width:1px;}> *:nth-child(2){position:relative;&::after{content:'';position:absolute;background-color:", ";right:100%;top:50%;height:1px;width:25px;}}&:last-child{&::before{bottom:50%;}}}"], ({
  theme
}) => theme.color['border-core-default'], ({
  theme
}) => theme.color['border-core-default']);
export default EditorRelatedConditionsContainer;